export const genreList = [
  {
    label: "Action and Adventure",
    value: "action_and_adventure",
  },
  {
    label: "Art",
    value: "art",
  },
  {
    label: "Any",
    value: "any",
  },
  {
    label: "Biography",
    value: "biography",
  },
  {
    label: "Business",
    value: "business",
  },
  {
    label: "Children's",
    value: "childrens",
  },
  {
    label: "Comics",
    value: "comics",
  },
  {
    label: "Cookbooks",
    value: "cookbooks",
  },
  {
    label: "Crime",
    value: "crime",
  },
  {
    label: "Fantasy",
    value: "fantasy",
  },
  {
    label: "Fiction",
    value: "fiction",
  },
  {
    label: "Health",
    value: "health",
  },
  {
    label: "History",
    value: "history",
  },
  {
    label: "Horror",
    value: "horror",
  },
  {
    label: "Humor",
    value: "humor",
  },
  {
    label: "Manga",
    value: "manga",
  },
  {
    label: "Memoir",
    value: "memoir",
  },
  {
    label: "Music",
    value: "music",
  },
  {
    label: "Mystery",
    value: "mystery",
  },
  {
    label: "Non-fiction",
    value: "non_fiction",
  },
  {
    label: "Philosophy",
    value: "philosophy",
  },
  {
    label: "Poetry",
    value: "poetry",
  },
  {
    label: "Psychology",
    value: "psychology",
  },
  {
    label: "Religion",
    value: "religion",
  },
  {
    label: "Romance",
    value: "romance",
  },
  {
    label: "Science",
    value: "science",
  },
  {
    label: "Science Fiction",
    value: "science_fiction",
  },
  {
    label: "Self-help",
    value: "self_help",
  },
  {
    label: "Sports and Leisure",
    value: "sports_and_leisure",
  },
  {
    label: "Thriller",
    value: "thriller",
  },
  {
    label: "Travel",
    value: "travel",
  },
];
